import { Row, Col, Container} from "reactstrap";
import React, {Component} from "react";
import "bootstrap/dist/css/bootstrap.css";
import Testimonial from "./Testimonial/TestimonialTypeTenth";

import Slider from "./Slider/Slider";
import {Avatar} from "antd";
import {User} from "../../../../components/Icons/Icons";
import classes from "./TestimonialsLayoutsTypeFourth.module.css"
import {Fade} from "react-awesome-reveal";

const strong = "Testimonials";
const title = "Testimonials";


class Testimonials extends Component {

    state = {
        persons: [
            {
                name: 'Ram Mohan, Head Of Biomedical',
                post: 'Bhagwan Mahaveer Jain Hospital, Bengaluru',
                description: 'We have been using this software since 2017 and it has made biomedical operations easy to manage. Their multi-location feature also helps me track operations in different locations.',
                avatar: null,
                link: './some-link',
            },
            {
                name: 'Joby K Varghese, Head of Biomedical',
                post: 'MOSC Medical College, Kerala',
                description: 'This software is feature rich and cost effective. We have been using this system to streamline asset management using the PM / Calibration calendars, service records and incident reporting and this has helped us reduce asset downtime and improve our metrics.',
                avatar: null,
                link: './some-link',
            },
        ]
    }

    renderCards () {
        const card = this.state.persons;
        const listItems = card.map((item, index) => {
            return (
                <Testimonial
                    key={index}
                    person={item.name}
                    post={item.post}
                    description={item.description}
                    dark={this.props.dark ? true : false}
                    link={item.link}
                >
                    {item.avatar ?
                        <Avatar
                            size={60}
                            src={item.avatar}
                        />
                        :
                        <Avatar
                            size={60}
                            icon={<User fill={"#ffffff"}/>}
                            style={{
                                fontSize: 0,
                                backgroundColor: '#345DEE',
                            }}
                        />
                    }
                </Testimonial>
            )
        });
        return (
            <Slider
                array={listItems}
                dark={this.props.dark ? true : false}
            />
        );
    }

    render() {

        return (
            <div>
                <section className={`section ${classes.testimonials} ${(this.props.dark) ?  `dark ${classes.dark}` : ''}`}>
                    <div className={classes.gridWrapper}>
                        <Container>
                            <Row className={classes.testimonialsRow}>

                                <Col lg="8" md="8" sm="10" className={`mx-auto text-center ${classes.leftColumn}`}>
                                    {/*<Fade top triggerOnce={true}>*/}
                                    {/*    <strong style={{display: 'block'}}>{strong}</strong>*/}
                                    {/*</Fade>*/}
                                    <Fade top delay={100} triggerOnce={true}>
                                        <h1 className="text-center">{title}</h1>
                                    </Fade>

                                </Col>

                                <Col lg="10" md="10" sm="10" className={`mx-auto ${classes.rightColumn}`}>
                                    {this.renderCards()}
                                </Col>

                            </Row>
                        </Container>
                    </div>
                </section>
            </div>
        )
    }
}

export default Testimonials
